import { useReducedMotion } from 'motion/react';
import { cn } from '@/lib/cn';

interface GradientDotsProps {
  dotSize?: number;
  spacing?: number;
  colorCycleDuration?: number;
  className?: string;
}

export function GradientDots({
  dotSize = 8,
  spacing = 10,
  colorCycleDuration = 240,
  className,
}: GradientDotsProps) {
  const reduced = useReducedMotion();
  const hexSpacing = spacing * 1.732;

  const bg = 'hsl(var(--auth-bg))';
  const c1 = 'hsl(var(--auth-dot-1))';
  const c2 = 'hsl(var(--auth-dot-2))';
  const c3 = 'hsl(var(--auth-dot-3))';
  const c4 = 'hsl(var(--auth-dot-4))';

  const style: React.CSSProperties = {
    backgroundColor: bg,
    backgroundImage: `
      radial-gradient(circle at 50% 50%, transparent 1.5px, ${bg} 0 ${dotSize}px, transparent ${dotSize}px),
      radial-gradient(circle at 50% 50%, transparent 1.5px, ${bg} 0 ${dotSize}px, transparent ${dotSize}px),
      radial-gradient(circle at 50% 50%, ${c1}, transparent 60%),
      radial-gradient(circle at 50% 50%, ${c2}, transparent 60%),
      radial-gradient(circle at 50% 50%, ${c3}, transparent 60%),
      radial-gradient(ellipse at 50% 50%, ${c4}, transparent 60%)
    `,
    backgroundSize: `
      ${spacing}px ${hexSpacing}px,
      ${spacing}px ${hexSpacing}px,
      200% 200%,
      200% 200%,
      200% 200%,
      200% ${hexSpacing}px
    `,
    backgroundPosition: `
      0px 0px,
      ${spacing / 2}px ${hexSpacing / 2}px,
      15% 25%,
      85% 20%,
      30% 90%,
      100% 60%
    `,
    animation: reduced
      ? undefined
      : `auth-glow-hue ${colorCycleDuration}s linear infinite`,
  };

  return (
    <div
      aria-hidden
      className={cn('absolute inset-0 pointer-events-none', className)}
      style={style}
    />
  );
}
